import { filter, find, forEach, includes } from "lodash-es";
import { HitType, MultiselectHitType } from "src/types/Algolia";
import { sortByAlphabet } from "./sortBy";
import { CategoryTreeSlugOrder } from "src/organisms/AlgoliaProductList/AlgoliaProductList";

export const getItemsToRefine = (ids: string[]): string[] =>
  filter(ids, (label) => {
    const parentId = label.split("||")[0];
    return !find(ids, (item) => includes(item, `||${parentId}`));
  }).map((label) => label.split("||").slice(0, 6).join("||"));

const childrenById = (
  list: HitType[],
  id: string,
  gender: string,
  suffix?: string,
  slugOrder?: CategoryTreeSlugOrder
) =>
  filter(list, (item) => includes(item.label, `||${id}||${gender}`))
    .map(({ label }) => {
      const [categoryId, name, slug, parentCategoryId] = label.split("||");
      return {
        label: suffix ? `${label}||${suffix}` : label,
        categoryId,
        name,
        slug,
        parentCategoryId,
      };
    })
    .sort(
      slugOrder
        ? (a, b) => slugOrder[a.slug] - slugOrder[b.slug]
        : (sortByAlphabet as (
            a: { label: string },
            b: { label: string }
          ) => number)
    ) as MultiselectHitType[];

const buildTreeItems = (
  list: MultiselectHitType[],
  hits: HitType[],
  gender: string,
  level: number,
  flatLabelsMap: { [p: string]: string },
  suffix?: string,
  slugOrder?: CategoryTreeSlugOrder
) => {
  forEach(list, (item) => {
    const id = item.label.split("||")[0];
    item.items = childrenById(hits, id, gender, suffix, slugOrder);
    forEach(
      item.items,
      (e) => (flatLabelsMap[e.label.split("||")[2]] = e.label)
    );
    if (level < 3) {
      buildTreeItems(
        item.items,
        hits,
        gender,
        level + 1,
        flatLabelsMap,
        suffix ? `${suffix}||${id}` : id,
        slugOrder
      );
    }
  });
};

// TODO: simplify generation and usage of the tree - increase a maintainability
// TODO: https://otrium.atlassian.net/browse/SHOP-2020
export const createCategoryTree = (
  items: HitType[],
  gender: string,
  slugOrder?: CategoryTreeSlugOrder
): { tree: MultiselectHitType[]; flatLabelsMap: { [p: string]: string } } => {
  const root = find(items, (item) => includes(item.label, `||0||${gender}`));
  if (!root) {
    return { tree: [], flatLabelsMap: {} };
  }
  const rootSlug = root.label.split("||")[2];
  const flatLabelsMap = { [rootSlug]: root.label };
  const tree = childrenById(items, "0", gender, undefined, slugOrder);
  tree.forEach(({ label }) => {
    const categorySlug = label.split("||")[2];
    flatLabelsMap[categorySlug] = label;
  });
  buildTreeItems(tree, items, gender, 1, flatLabelsMap, undefined, slugOrder);
  return { tree, flatLabelsMap };
};
